/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Link_Github_CmsInputs */

const en_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const ar_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظام محتوى GitHub`)
};

const bn_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const de_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const es_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CMS GitHub`)
};

const fr_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CMS GitHub`)
};

const pt_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const zh_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const tr_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const ru_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

const pl_quick_link_github_cms = /** @type {(inputs: Quick_Link_Github_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub CMS`)
};

/**
* | output |
* | --- |
* | "GitHub CMS" |
*
* @param {Quick_Link_Github_CmsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const quick_link_github_cms = /** @type {((inputs?: Quick_Link_Github_CmsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Link_Github_CmsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_quick_link_github_cms(inputs)
	if (locale === "bn") return bn_quick_link_github_cms(inputs)
	if (locale === "de") return de_quick_link_github_cms(inputs)
	if (locale === "es") return es_quick_link_github_cms(inputs)
	if (locale === "fr") return fr_quick_link_github_cms(inputs)
	if (locale === "pt") return pt_quick_link_github_cms(inputs)
	if (locale === "zh") return zh_quick_link_github_cms(inputs)
	if (locale === "tr") return tr_quick_link_github_cms(inputs)
	if (locale === "ru") return ru_quick_link_github_cms(inputs)
	if (locale === "pl") return pl_quick_link_github_cms(inputs)
	return en_quick_link_github_cms(inputs)
});